import React from 'react';
import classNames from 'classnames';

const Wrapper = ({ boxed, children }) => (
  <div className={classNames('wrapper', (boxed ? 'wrapper-boxed' : ''))}>{children}</div>
);

export default Wrapper;
